import React from 'react';
import { Flex, Typography } from '@banhala/ui-kit';
import type { ProductInfoOption } from 'shared/src/api/goodsService';

interface Props {
  options: ProductInfoOption[];
}

export const MeasurementTable: React.FC<Props> = ({ options }) => {
  return (
    <Flex
      borderTopWidth={2}
      borderBottomWidth={2}
      borderColor={'content_secondary'}
    >
      {options.map((option, index) => (
        <Flex.Row
          key={option.sno}
          borderTopWidth={index > 0 ? 1 : 0}
          borderColor={'border_secondary'}
        >
          <Flex.Center
            width={64}
            backgroundColor={'bg_secondary'}
            padding={{ vertical: 16, horizontal: 8 }}
          >
            <Typography type={'body3'} color={'content_tertiary'}>
              {option.name}
            </Typography>
          </Flex.Center>
          <Flex.Row flex={1} padding={{ vertical: 16, horizontal: 8 }}>
            {option.choices.map(choice => (
              <Flex.Center flex={1} key={choice.sno}>
                <Typography
                  type={choice.is_chosen ? 'subtitle2' : 'body2'}
                  color={
                    choice.is_chosen ? 'content_primary' : 'content_disabled'
                  }
                >
                  {choice.name}
                </Typography>
              </Flex.Center>
            ))}
          </Flex.Row>
        </Flex.Row>
      ))}
    </Flex>
  );
};
